import styled from 'styled-components'
import media from './media'


const StyledNaviBar = styled.div` 
    display: block;
    margin: 0 auto;
    background: #fff;
    text-transform: uppercase;
    position: relative;

    img {
        height: auto;
        max-height: 90px;
        width: auto;
        max-width: 100%;
    }

    .navbar {
        box-shadow: none;
    }

    .navbar .mr-auto {
        width: 100%;
        justify-content: flex-end;
        line-height: 42px;
    }

    .navbar .navbar-nav .nav-link {
        font-weight: 600;
        font-size: 16px;
        font-style: normal;
        letter-spacing: 1px;
        text-decoration: none;
        line-height: 1.5em;
        color: #582C83;

        &.active {
            color: #F1c400;
        }

        &:hover {
            color: #F1c400;
            border-bottom: 0;
        }

    }

    /* dropdown menu */
    .navbar.navbar-light .navbar-nav .nav-item .nav-link {
        color: #582C83;
        line-height: 1.5em;
        margin: 0 10px;
        padding-bottom: 0;

        &:hover, &.active {
            transition: 0.35s;
            color: #F1c400;
            display: block;
        }

    }

    a.dropdown-toggle.nav-link  {
        
        &.active, &:hover, &:focus {
            color: #F1C400 !important;
            display: block;
        }
    }

    div.dropdown-menu {
        padding: 10px 15px;
    }

    .navbar .dropdown-menu .dropdown-item {
        color: #582C83;
        padding: 10px 0 0;

        &:hover, &.active {
            color: #F1c400;
            background: #ffffff;
            transition: .35s;

        }
    }

    span.underline-span {
        color: #582C83;

        &:hover, &.active, &:active {
            color: #F1c400;
            display: block;
        }
    }


    ${media.mobileS`
        .navbar .nav-item .nav-link {
            padding-left: 0px !important;
            margin: 0;
        }

        .fixed-top {
            width: 100%;
            top: 40px;
        }

        .fas {
            margin-left: 0;
            padding-left: 0 !important;
        }

        a.nav-link.user {
            border-right: 0;
        }

        .dropdown-menu .dropdown-item {
            line-height: 1em;
            font-size: 17px;
            font-weight: 600;
        }

        a.dropdown-toggle.nav-link  {
            &.active, &:hover, &:focus {
                color: #F1C400 !important;
                display: block;
            }
        }

        a.underline.close-btn.nav-link { 
            padding-left: 9px;
        }

        .navbar .navbar-nav .nav-link {
            margin-left: 10px;
        }

        div.nav-item {
            position: relative;
            color: #582C83;
        }

        div.nav-item .cart-basket {
            font-size: .8rem;
            font-weight: 600;
            position: absolute;
            top: 6px;
            right: 248px;
            color: #582C83;
            line-height: 0;
        }

        .cart-icon {
            margin-left: 10px;
        }
    `}

    ${media.mobileM`
        div.nav-item .cart-basket {
            right: 303px;
        }

    `}

    ${media.mobileL`
        div.nav-item .cart-basket {
            right: 353px;
        }
    `}

    ${media.tablet`
        .navbar .nav-item .nav-link .fas {
            padding-left: 0;
            padding-right: 0;
        }

        a.dropdown__item.user.nav-link {
            line-height: 1em;
        }

        .fixed-top {
            width: 100%;
            /* height: 14vh; */
            top: 26px;
            padding-top: 10px;
            padding-bottom: 10px;
        }

        div.nav-item .cart-basket {
            right: 680px;
        }
    `}

    ${media.tabletL`
        a.nav-link.user {
            border-right: 2px solid #582C83;
            margin-left: 10px !important;
            margin-right: 0 !important;
        }
        
        .cart-icon {
                margin-right: 10px;
                margin-left: 30px;

            }

        .navbar-brand {
            width: 100%;
            margin: 0 auto;
        }

        .accordion.nav-link {
            padding-right: 0 !important;
        }

        .navbar .nav-item .nav-link {
            padding-left: 0;
            padding-right: 0;
            margin: 0;
        }

        .navbar .nav-item .nav-link.user {
            padding-right: 10px;
            padding-bottom: 10px !important;
        }

        .dropdown-menu .dropdown-item {
            line-height: 1.5em;
        }

        a.dropdown-toggle.nav-link  {
            padding-bottom: 0;

            &:hover {
                padding-bottom: 0;
                border-bottom: 2px solid #582C83;
            }
        }

        .navbar .dropdown-menu .dropdown-item {
            &:hover {
                border-bottom: 2px solid #582C83;
            }

        }

        .navbar.navbar-light .navbar-nav .nav-item .nav-link {
            
            &:hover {
                border-bottom: 2px solid #582C83;
                padding-bottom: .2em;

            }
        }

        a.underline.close-btn.nav-link {
            padding-right: 0;
        }

        a.nav-link.user, a.nav-link.nav-item {
            &:hover {
                    border-bottom: 0 !important;
                }
        }

        div.nav-item .cart-basket {
            right: 2px;
        }

        .navbar .navbar-nav .nav-link {
            margin-left: 0px;
        }


        ${media.laptop`    

            a.nav-link.user {
                border-right: 2px solid #582C83;
                line-height: 1.5em;
                margin-right: 0 !important;

            }
            
        `}

    `}
`

export default StyledNaviBar;